import { createActionGroup, props } from '@ngrx/store';
import { PaginatedResult, Prospect, UpdateProspectPayload } from '@niko-crm/ui';

export const ProspectKanbanActions = createActionGroup({
  source: 'Prospects Kanban',
  events: {
    /** `append: false` (page 1) replaces the column; `true` adds to its tail. */
    'Load Kanban Column': props<{
      stageId: string;
      page: number;
      limit: number;
      filters: Record<string, unknown>;
    }>(),
    'Load Kanban Column Success': props<{
      stageId: string;
      result: PaginatedResult<Prospect>;
      append: boolean;
    }>(),
    'Load Kanban Column Failure': props<{ stageId: string; error: string }>(),

    /** Wipes every column bucket: a new filter set makes prior pages meaningless. */
    'Reset Kanban Columns': props<Record<string, never>>(),

    /** Optimistic: reducer relocates `prospect` immediately, `moveProspectStageFailure` rolls it back. */
    'Move Prospect Stage': props<{
      prospect: Prospect;
      fromStageId: string;
      toStageId: string;
      payload: UpdateProspectPayload;
    }>(),
    'Move Prospect Stage Success': props<{
      prospect: Prospect;
      fromStageId: string;
      toStageId: string;
    }>(),
    'Move Prospect Stage Failure': props<{
      prospect: Prospect;
      fromStageId: string;
      toStageId: string;
      error: string;
    }>(),
  },
});
